export default __webpack_public_path__ + "static/media/puzsq.3864e15a.jpg";